import { render, staticRenderFns } from "./Airplane.vue?vue&type=template&id=2a2457dd&scoped=true&"
var script = {}
import style0 from "./Airplane.vue?vue&type=style&index=0&id=2a2457dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2457dd",
  null
  
)

export default component.exports